'use client'

import { BentoItemFragment } from '@/gql/generated/graphql'
import { BentoItem } from './bento-item'

interface HeroBentoProps {
  items: BentoItemFragment[]
}

export function HeroBento({ items }: HeroBentoProps): React.ReactElement {
  if (items.length < 2) {
    return <></>
  }

  const bentoBoxName = 'Hero'

  return (
    <div className="h-[350px] w-full">
      <div className="gap-md grid h-full w-full grid-cols-1 sm:grid-cols-2 lg:grid-cols-3">
        <div className="col-span-1 h-full">
          <BentoItem bentoItem={items[0]} bentoBoxName={bentoBoxName} bentoBoxPosition={0} />
        </div>
        <div className="col-span-1 block h-full lg:col-span-2">
          <BentoItem bentoItem={items[1]} bentoBoxName={bentoBoxName} bentoBoxPosition={1} />
        </div>
      </div>
    </div>
  )
}
